import React from 'react';

var Placeholder = function Placeholder() {
  return React.createElement("div", {
    style: "padding: 1em; background: #eee; color: #000; font-size: 1.3em;"
  }, React.createElement("strong", null, "Nenhum player selecionado."));
};

export default Placeholder;